module.exports = {
    getDevice: {
        url: '/user/device'
    },
    getDeviceByNo: {
        url: '/device/detail'
    },
    openDevice: {
        url: '/device/open'
    },
    openTrialDevice: {
        url: '/trial_device/open'
    },
    deviceUsePage: {
        url: '/device/use_record/page'
    }
};